import React, { createContext, useState } from "react";

const AuthContext = createContext({});

const AuthProvider = (props) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [cart, setCart] = useState([]);
  const [selected, setSelected] = useState({
    date: "",
    employee: null,
    location: null,
    timeSlot: null,
    email: user?.email,
    name: user?.displayName,
    phoneNumber: user?.phoneNumber,
    slot: null,
    cardNumber: "",
    cvc: "",
    expiry: "",
    payInStore: false,
  });

  const authContextValue = {
    cart,
    setCart,
    selected,
    setSelected,
  };

  return <AuthContext.Provider value={authContextValue} {...props} />;
};

const useAuth = () => React.useContext(AuthContext);

export { AuthProvider, useAuth };
